import {
    processCoupons,
    processDividends,
    processItemCoupons,
    processItemDividends,
    sortCoupons,
    sortDividends
} from "#app/pages/Relations/Active/Actives/utils/investmentDataProcessor";
import {ActiveConstants} from "finhelper";

export const addDividendsAndCoupons = (investItem) => {

    ActiveConstants.isPackage(investItem.type_id)
    {
        // Применяем ваши методы форматирования
        investItem.dividends = processDividends(investItem.dividends);
        if (investItem.item?.dividends) {
            investItem.dividends.push(...processItemDividends(investItem.item.dividends));
        }
        investItem.dividends = sortDividends(investItem.dividends);

        investItem.coupons = processCoupons(investItem.coupons);
        if (investItem.item?.coupons) {
            investItem.coupons.push(...processItemCoupons(investItem.item.coupons));
        }
        investItem.coupons = sortCoupons(investItem.coupons);
    }

    return investItem
}
